import React, { useState, useEffect } from 'react'

import { Box, Flex} from '@chakra-ui/react'
import { SiBrandfolder } from 'react-icons/si'
import { AiOutlineIdcard } from 'react-icons/ai'

export default function DsrRoomLogoDisplayModeModule({
  handleSaveRoomSettings,
  logoDisplayOption
}) {

  const [logoDisplayMode, setLogoDisplayMode] = useState("default")

  useEffect(() => {
    if (logoDisplayOption) {
      setLogoDisplayMode(logoDisplayOption)
    }

  }, [logoDisplayOption]);

  return (
      <>
        <Flex w='100%' justify='space-between' align='center' py='1.5em'>
          <Box>
            <Box lineHeight='1.25em' fontWeight='500'>
              Logo display
            </Box>
            <Box fontSize='0.75em' lineHeight='1.25em' fontWeight='400' color='gray.500' mt='0.2em'>
              Customise how logos are displayed
            </Box>
          </Box>
        </Flex>


          <Flex w='100%' p='0.5em'>
            <Flex w='100%' gap={8}>
              <Box flex='1' border={logoDisplayMode === "default" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "default" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "default" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                 onClick={() => {
                  if (logoDisplayMode !== "default") {
                      handleSaveRoomSettings("logo-display-option",{option:"default"});
                      setLogoDisplayMode("default");
                    }
                  }
                }
                transition='all 0.1s ease-in-out'
                justifyItems='center'
              >
                <Flex w='3em' h='3em' justify='center' align='center'>
                  <Box as={SiBrandfolder} boxSize='1em' />
                </Flex>


                <Box fontSize='0.8em' mt='1em'>Normal size</Box>
              </Box>

              <Box flex='1' border={logoDisplayMode === "large-logos" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "large-logos" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "large-logos" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                onClick={() => {
                  if (logoDisplayMode !== "large-logos") {
                      handleSaveRoomSettings("logo-display-option",{option:"large-logos"});
                      setLogoDisplayMode("large-logos");
                    }
                  }
                }
                transition='all 0.1s ease-in-out'
                justifyItems='center'
              >
                <Flex w='3em' h='3em' justify='center' align='center'>
                  <Box as={SiBrandfolder} boxSize='2em' />
                </Flex>
                <Box fontSize='0.8em' mt='1em'>Larger logos</Box>
              </Box>

              <Box flex='1' border={logoDisplayMode === "nametag" ? '1px solid' : '1px dashed'} borderColor={logoDisplayMode === "nametag" ? "brand.500" : 'gray.200'} bg={logoDisplayMode === "nametag" && 'brand.50'} rounded='10px' p='1em' cursor='pointer'
                onClick={() => {
                  if (logoDisplayMode !== "nametag") {
                      handleSaveRoomSettings("logo-display-option",{option:"nametag"});
                      setLogoDisplayMode("nametag");
                    }
                  }
                }
                transition='all 0.1s ease-in-out'
                justifyItems='center'
              >
                <Flex w='3em' h='3em' justify='center' align='center'>
                  <Box as={AiOutlineIdcard} boxSize='1.5em' />
                </Flex>
                <Box fontSize='0.8em' mt='1em'>Nametag</Box>
              </Box>
            </Flex>
          </Flex>

      </>
  )

}
